import { BoardView } from "@common-models/board-views";
import { getSelectedBoardId } from "@common-reducers/BoardsSelectors";
import { boardViewSelectByQuery, viewFiltersSelectByQuery } from "@common-reducers/DBServiceThunks";
import { useAppSelector } from "@common-reducers/hooks/store.hook";
import AdvancedFilterRowShadcn from "./advanced_filters_row_shadcn"; // Using new Shadcn component

export interface ViewFilter {
  _id?: string;
  viewId?: string;
  filterColumnId?: string; 
  filterAndOr?: string;
  filterOperator?: string;
  filterValue?: any;
  owner?: string;
}

const AdvancedFiltersShadcn = () => {
  const currentBoardId = useAppSelector(getSelectedBoardId);
  const currentBoardView = useAppSelector((state) => state.TasksReducer.currentBoardView);
  const [boardView]: BoardView[] = useAppSelector((state) => boardViewSelectByQuery(state.DBBoardViewReducer, { boardId: currentBoardId, _id: currentBoardView.id }));
  const viewId = boardView?._id ?? currentBoardId;
  const allViewFilters: ViewFilter[] = useAppSelector((state) =>
    viewFiltersSelectByQuery(
      state.DBViewFiltersReducer,
      {
        viewId,
        $or: [{ deleted: { $exists: false } }, { deleted: false }],
      },
      null,
      {
        updatedAt: 1
      }
    )
  );

  const isVeryFirstFilterRow = allViewFilters.length === 0 ? true : false;

  return (
    <div className="w-full flex flex-col gap-2">
      {allViewFilters.map((viewFilter, index) => (
        <AdvancedFilterRowShadcn
            key={viewFilter._id}
            viewFilterId={viewFilter._id ?? null}
            isFirstFilter={index === 0 ? true : false}
            viewId={viewId}
        />
      ))}
      <AdvancedFilterRowShadcn
        key={null}
        viewFilterId={null}
        viewId={null} 
        isFirstFilter={isVeryFirstFilterRow} 
      />
    </div>
  );
};

export default AdvancedFiltersShadcn;
